import React, { useState } from "react";
import { oneOfType, arrayOf, string, bool, shape } from "prop-types";
import moment from "moment";

import GridTable from "pages/_components/GridTable/GridTable";
import InfoTag from "pages/echeck/components/InfoTag";
import classNames from "classnames";
import * as i18n from "util/i18n";
import CustomText from "pages/_components/CustomText/CustomText";
import "react-circular-progressbar/dist/styles.css";
import FormattedAmount from "pages/_components/FormattedAmount";
import CustomData from "pages/_components/CustomData/CustomData";
import Image from "pages/_components/Image";
import Container from "pages/_components/Container";
import getCellPlacement from "../../../../util/helpers/table";

const Fees = ({ isDesktop, fees, detallePrestamo, feeType }) => {
    const pendingFees = fees ? fees.filter((x) => moment(x.fechaVencimiento).isSameOrAfter(moment())) : [];
    const overdueFees = fees ? fees.filter((x) => moment(x.fechaVencimiento).isBefore(moment())) : [];
    const paidFees = fees ? fees.filter((x) => x.estado === "Cancelado") : [];

    const statusTagColor = (status) => {
        switch (status) {
            case "Vencida":
                return "error";
            case "A vencer":
                return "info";
            case "Pagada":
                return "success";
            default:
                return "error";
        }
    };

    const [isOpen, setIsOpen] = useState(null);
    const handleAccordion = (i) => {
        if (isOpen === i) {
            return setIsOpen(null);
        }

        return setIsOpen(i);
    };
    const getCellProps = (row, col, cols) => getCellPlacement(row, col, { isDesktop, totalColumns: cols });

    const renderMoreFeeData = (data, i) => (
        <GridTable
            className={`discounts-echeq-simulation__list-details ${isOpen === i ? "discounts-echeq-simulation__open" : "discounts-echeq-simulation__close"
                }`}>
            <GridTable.Container key="1551" columns={4} rows={2} className="px-13 pb-9">
                <GridTable.Data columnStart={1} rowStart={1}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.confirm.interests", "Intereses")}
                        titleTextType="STRING"
                        valueText={<FormattedAmount currency="ARS" quantity={data.interes || 0} />}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>

                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.confirm.iva", "IVA")}
                        titleTextType="STRING"
                        valueText={<FormattedAmount currency="ARS" quantity={data.iva || 0} />}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>

                <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 3}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.confirm.IIBB", "Percepción de IIBB")}
                        titleTextType="STRING"
                        valueText={<FormattedAmount currency="ARS" quantity={data.ingresosBrutos[0]?.importe || 0} />}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>

                <GridTable.Data columnStart={isDesktop ? 4 : 1} rowStart={isDesktop ? 1 : 4}>
                    <CustomData
                        titleText={i18n.get("loans.stamps.label", "Sellos")}
                        titleTextType="STRING"
                        valueText={<FormattedAmount currency="ARS" quantity={data.impuestoSello || 0} />}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>

                <GridTable.Data columnStart={1} rowStart={isDesktop ? 2 : 5}>
                    <CustomData
                        titleText={i18n.get("loans.amortization.label", "Amortización")}
                        titleTextType="STRING"
                        valueText={<FormattedAmount currency="ARS" quantity={data.capital || 0} />}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>

                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 2 : 6}>
                    <CustomData
                        titleText={i18n.get("loans.perception.iva.label", "Percepción IVA")}
                        titleTextType="STRING"
                        valueText={<FormattedAmount currency="ARS" quantity={data.ivas[0]?.monto || 0} />}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>

                <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 2 : 7}>
                    <CustomData
                        titleText={i18n.get("loans.jurisdiction.iibb.label", "Jurisdicción IIBB")}
                        titleTextType="STRING"
                        valueText={data.ingresosBrutos[0]?.jurisdiccion || ""}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>

                <GridTable.Data columnStart={isDesktop ? 4 : 1} rowStart={isDesktop ? 2 : 8}>
                    <CustomData
                        titleText={i18n.get("loans.jurisdiction.stamps.label", "Jurisdicción sellos")}
                        titleTextType="STRING"
                        valueText={detallePrestamo.impuestoSelloJuris || ""}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable>
    );

    const renderFees = (feesToShow, status) => (
        <Container>
            <div className="discounts-echeq-simulation">
                <ul className="discounts-echeq-simulation__list">
                    {feesToShow.map((item, i) => (
                        <li key={item.nroCuota} onClick={() => handleAccordion(i + status)}>
                            <GridTable
                                className={classNames("discounts-echeq-simulation__list-header", {
                                    "pb-6": isOpen === i + status,
                                })}>
                                <GridTable.Body>
                                    <GridTable.Container key="1551" className="px-6 pt-9 pb-9">
                                        <GridTable.Data
                                            columnStart={1}
                                            columnWidth={1}
                                            rowStart={1}
                                            className="modalities"
                                            alignX={isDesktop ? "flex-start" : "flex-start"}
                                            alignY={isDesktop ? "center" : "start"}
                                            flexDirection={isDesktop ? "row" : "column"}
                                            {...getCellProps(1, 1, 4)}>
                                            <CustomText
                                                className="font-weight-700 mr-6"
                                                text={`Cuota ${item.nroCuota}  `}
                                            />
                                            <InfoTag
                                                type="info"
                                                message={status}
                                                tagBackground={statusTagColor(status)}
                                            />
                                        </GridTable.Data>
                                        <GridTable.Data
                                            columnWidth={1}
                                            className="modalities"
                                            alignX={isDesktop ? "center" : "flex-start"}
                                            alignY={isDesktop ? "center" : "start"}
                                            flexDirection={isDesktop ? "row" : "column"}
                                            {...getCellProps(1, 2, 4)}>
                                            <CustomData
                                                titleText={i18n.get(
                                                    "unsecured.loans.confirm.expirationDate",
                                                    "Fecha de vencimiento",
                                                )}
                                                titleTextType="STRING"
                                                valueText={moment(item?.fechaVencimiento).utc().format("DD/MM/YYYY")}
                                                valueTextType="STRING"
                                            />
                                        </GridTable.Data>
                                        <GridTable.Data
                                            columnWidth={1}
                                            className="modalities"
                                            alignX={isDesktop ? "center" : "flex-start"}
                                            alignY={isDesktop ? "center" : "start"}
                                            flexDirection={isDesktop ? "row" : "column"}
                                            {...getCellProps(1, 3, 4)}>
                                            <CustomData
                                                titleText={i18n.get(
                                                    "unsecured.loans.detail.actualFees.amountToPay",
                                                    "Monto a pagar",
                                                )}
                                                titleTextType="STRING"
                                                valueText={
                                                    <FormattedAmount currency="ARS" quantity={item.totalCuota} />
                                                }
                                                valueTextType="STRING"
                                            />
                                        </GridTable.Data>
                                        <GridTable.Data
                                            columnWidth={1}
                                            alignX={isDesktop ? "flex-end" : "flex-start"}
                                            alignY={isDesktop ? "center" : "start"}
                                            {...getCellProps(1, 4, 4)}>
                                            <div
                                                className={classNames("discounts-echeq-simulation__arrow svg-wrapper", {
                                                    "arrow-rotate": isOpen === i + status,
                                                })}>
                                                <Image src="images/chevromRight.svg" className="svg-icon" />
                                            </div>
                                        </GridTable.Data>
                                    </GridTable.Container>
                                </GridTable.Body>
                            </GridTable>
                            <hr
                                className={`dotted discounts-echeq-simulation__line ${isOpen === i + status
                                        ? "discounts-echeq-simulation__open"
                                        : "discounts-echeq-simulation__close"
                                    }`}
                            />
                            {renderMoreFeeData(item, i + status)}
                        </li>
                    ))}
                </ul>
            </div>
        </Container>
    );

    if (feeType === "A" && pendingFees?.length <= 0 && overdueFees?.length <= 0) {
        return (
            <div className="container--alert" role="alert">
                <div className="alert alert-info">
                    <CustomData
                        icon="information_fill.svg"
                        titleText="No tenés cuotas pendientes aún"
                        keepSpaceIfNoValue={false}
                    />
                </div>
            </div>
        );
    }
    if (feeType === "P" && paidFees?.length <= 0) {
        return (
            <div className="container--alert" role="alert">
                <div className="alert alert-info">
                    <CustomData
                        icon="information_fill.svg"
                        titleText="No tenés cuotas pagadas aún"
                        keepSpaceIfNoValue={false}
                    />
                </div>
            </div>
        );
    }

    return (
        <>
            {feeType === "A" && (
                <div className="container pb-8">
                    {overdueFees?.length > 0 && (
                        <>
                            <h3 className="col-span-full mb-7">{i18n.get("unsecured.loans.fees.overdue.title")}</h3>
                            {renderFees(overdueFees, "Vencida")}
                            <hr className="dotted discounts-echeq-simulation__line mt-10 mb-7" />
                        </>
                    )}
                    {pendingFees?.length > 0 && (
                        <>
                            <h3 className="col-span-full mb-7">{i18n.get("unsecured.loans.fees.due.title")}</h3>
                            {renderFees(pendingFees, "A vencer")}
                        </>
                    )}
                </div>
            )}
            {feeType === "P" && <>{renderFees(paidFees, "Pagada")}</>}
        </>
    );
};

Fees.propTypes = {
    detallePrestamo: shape({}).isRequired,
    fees: arrayOf(shape({})).isRequired,
    feeType: string.isRequired,
    isDesktop: oneOfType([string, bool]),
};

Fees.defaultProps = {
    isDesktop: false,
};

export default Fees;
